export enum StandardAttributes {
    Name = 'name',
    Type = 'type',
    Description = 'description',
  };